import React from 'react';
import { Instagram, Phone, Mail } from 'lucide-react';
import { BRAND, CONTACT } from '../lib/butterstone';

const Footer = () => (
  <footer className="bg-[#12201a] text-white/80" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 grid md:grid-cols-3 gap-10">
      <div>
        <h3 className="font-serif text-3xl text-white">{BRAND.name}</h3>
        <p className="text-[10px] tracking-[0.28em] uppercase text-[#6E9A5E] mt-2">{BRAND.group}</p>
        <p className="text-white/60 text-sm mt-4 max-w-xs">A premium riverside property and coffee estate in the Western Ghats of Sakleshpur.</p>
      </div>
      <div>
        <p className="text-white/50 text-xs tracking-widest uppercase mb-4">Explore</p>
        <ul className="space-y-2 text-sm">
          {['Gallery','Activities','Stay','Reviews','About','Nearby','Contact'].map(x => (
            <li key={x}><button onClick={() => document.querySelector(`#${x.toLowerCase()}`)?.scrollIntoView({behavior:'smooth'})} className="hover:text-white transition-colors">{x}</button></li>
          ))}
        </ul>
      </div>
      <div>
        <p className="text-white/50 text-xs tracking-widest uppercase mb-4">Reach us</p>
        <div className="space-y-3 text-sm">
          <a href={`tel:+91${CONTACT.phone1}`} className="flex items-center gap-2 hover:text-white"><Phone size={15} /> {CONTACT.phone1Display}</a>
          <a href={`tel:+91${CONTACT.phone2}`} className="flex items-center gap-2 hover:text-white"><Phone size={15} /> {CONTACT.phone2Display}</a>
          <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 hover:text-white break-all"><Mail size={15} /> {CONTACT.email}</a>
          <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white"><Instagram size={15} /> {CONTACT.instagramHandle}</a>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 text-center text-white/40 text-xs">
      © {new Date().getFullYear()} {BRAND.name} · {BRAND.group}. All rights reserved.
    </div>
  </footer>
);

export default Footer;
